import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './income.module.css';
import { Table } from 'antd';
import IncomeCheck from './IncomeCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../report/ReportCheck';

function IncomeListApproved(props) {
  const [list, setList] = useState([]);
  useEffect(() => {
      if (props.list) {
          const arr = props.list.filter((item) => item.ddsr_sp_state === '3' || item.ddsr_sp_state === '4' || item.ddsr_sp_state === '5'|| item.ddsr_sp_state === '6');
          arr.sort((a, b) => new Date(b.ddsr_sp_ctime) - new Date(a.ddsr_sp_ctime));
          setList(arr);
      }
  }, [props.list]);

  const columns = [
      {
          title: '收款客户  ',
          dataIndex: 'ddsr_kh_name',
          key: 'ddsr_kh_name',
          width: "20%",
          render: (_, record) =>  <IncomeCheck
                                        type='button'
                                        ddsr_id={record.ddsr_sp_ddsr_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddsr_bzd_id={record.ddsr_bzd_id}
                                        ddsr_price={record.ddsr_price}
                                        ddsr_content={record.ddsr_content}
                                        ddsr_date={record.ddsr_date}
                                        ddsr_date_end={record.ddsr_date_end}
                                        ddsr_bzd_name={record.ddsr_bzd_name}
                                        ddsr_bzd_danhao={record.ddsr_bzd_danhao}
                                        ddsr_type_id={record.ddsr_type_id}
                                        ddsr_type_name={record.ddsr_type_name}
                                        ddsr_kh_id={record.ddsr_kh_id}
                                        ddsr_kh_name={record.ddsr_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddsr_num={record.ddsr_num}
                                        ddsr_amount={record.ddsr_amount}
                                        ddsr_state={record.ddsr_state}
                                        ddsr_bm_id={record.ddsr_bm_id}
                                        ddsr_bm_name={record.ddsr_bm_name}
                                        ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                        ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                        ddsr_image_name={record.ddsr_image_name}
                                        ddsr_image_file={record.ddsr_image_file}
                                        ddsr_ctime={record.ddsr_ctime}
                                        ddsr_sp_state={record.ddsr_sp_state}
                                        ddsr_sp_ddsr_kh_name={record.ddsr_sp_ddsr_kh_name}
                                        ddsr_sp_kh_name={record.ddsr_sp_kh_name}
                                        ddsr_sp_yh_id={record.ddsr_sp_yh_id}
                                        ddsr_sp_yh_name={record.ddsr_sp_yh_name}
                                        ddsr_sp_dsbzd_name={record.ddsr_sp_dsbzd_name}
                                        ddsr_sp_dsbzd_id={record.ddsr_sp_dsbzd_id}
                                        ddsr_sp_dsbzd_danhao={record.ddsr_sp_dsbzd_danhao}
                                        yh_qx={props.yh_qx}
                                    />
      },
      {
          key: 'ddsr_sp_ddsr_amount',
          dataIndex: 'ddsr_sp_ddsr_amount',
          title: "收款金额",
          width: "6%",            
          render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          })}</span>
      },
    
      {
          key: 'ddsr_sp_ddsr_name',
          dataIndex: 'ddsr_sp_ddsr_name',
          title: "收款事由",
          width: "8%",
          render: (text, record) => <Copy title={text}/>
      },
      {
          key: 'ddsr_sp_dsbzd_name',
          dataIndex: 'ddsr_sp_dsbzd_name',
          title: "团队名称",
          width: "8%",
          render: (text, record) => <ReportCheck dsbzd_name={record.ddsr_sp_dsbzd_name} dsbzd_id={record.ddsr_sp_dsbzd_id} dsbzd_danhao={record.ddsr_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
      },
      {
          key: 'ddsr_sp_uname',
          dataIndex: 'ddsr_sp_uname',
          title: "提交记录",
          width: "8%",
          render: (text, record) => <>{record.ddsr_sp_uname} {record.ddsr_sp_ctime}</>,
      },
      {
          title: '状态',
          dataIndex: 'ddsr_sp_state',
          width: '5%',
          key: 'ddsr_sp_state',            
          render:(text) => <StateTag state={text} />
      },       
      {
          title: '编号',
          dataIndex: 'ddsr_sp_ddsr_id',
          width: '5%',
          key: 'ddsr_sp_ddsr_id',                        
      },    
  ]
  return (
      <>
          <Table 
              className={classes.pinkHeader}
              size='small'
              bordered
              dataSource={list} 
              columns={columns} 
              rowKey='ddsr_sp_id'
              locale={{
                  emptyText: '暂无收款单' // This will display text when the table is empty
              }}
          />

      </>
  )
}

export default IncomeListApproved